import { Modal } from "@mui/material"
import { Root, StyledContainer, Title, ContainerBtn, Btn, Subtitle } from "./styles"

interface IModalNoItems {
  open: boolean
  handleClose: () => void
}

export const ModalNoItems = ({ handleClose, open }: IModalNoItems) => {
  return (
    <Modal open={open}>
      <Root>
        <StyledContainer>
          <Title>Aoba! Pode ficar tranquilo. </Title>
          <Subtitle> No momento não existe nenhum item necessitando abastecimento. </Subtitle>
          <ContainerBtn>
            <Btn onClick={handleClose}>Beleza! 👍</Btn>
          </ContainerBtn>
        </StyledContainer>
      </Root>
    </Modal>
  )
}
